<template>
  <div>
    <PageTitle title="Daily Stock Details" />
    <v-container fluid class="lighten-12 content">
      <v-col cols="12" md="12" class="pa-3">
        <v-card class>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items" :key="item.tab">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <WarehouseStock v-if="item.tab == 'Warehouse'" />
              <ShopStock v-if="item.tab == 'Shop'" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import WarehouseStock from './WarehouseStock';
import ShopStock from './ShopStock';

export default {
  data: () => ({
    tab: 'Shop Products',
    items: [
      { tab: 'Warehouse', content: 'this is credit tab' },
      { tab: 'Shop', content: 'this is credit tab' },
    ],
  }),
  components: {
    PageTitle,
    TableFilters,
    WarehouseStock,
    ShopStock,
  },
};
</script>
